/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".close-button[_ngcontent-%COMP%]{width:1.5em;opacity:1}.modal-header[_ngcontent-%COMP%]{border-bottom:none}.brand[_ngcontent-%COMP%]{color:grey;font-weight:700;font-size:1.5em;line-height:1.3em;height:1.3em}.btn-width[_ngcontent-%COMP%]{min-width:80px;max-width:80px}\n/*# sourceMappingURL=info-modal.component.css.map*/"];
export { styles as styles };
